(function () {
    'use strict';
    var module = angular.module("app");
    module.factory("keyedStorage", [
        '$localStorage',
        function ($localStorage) {

            function getOrCreateContainer(key, defaultValue) {
                var defaults = {};
                defaults[key] = defaultValue;
                var storage = $localStorage.$default(defaults);
                return storage[key];
            }

            var service = {
                getOrCreateContainer: getOrCreateContainer
            };
            return service;
        }
    ]);
}());